export const STATUS_ID = {
  UNAVAILABLE: 0,
  AVAILABLE: 1,
  NEW: 2,
  WAITING: 3,
  APPROVED: 4,
  COMPLETED: 5,
  REJECTED: 6,
  CANCELED: 7,
  DELETED: 8,
}

export const STATUS_USER = {
  DEACTIVE: 0,
  ACTIVE: 1,
  PRE_DEACTIVE: 2,
}

export const COMPLAINT_ID = {
  WAITING: 0,
  APPROVED: 1,
  REJECTED: 2,
}

export const ISSUES_ID = {
  ISSUE_ID_UPDATE_BANK_INFO: 5,
  ISSUE_ID_END_CONTRACT: 10,
  ISSUE_ID_LEAVE_REQUEST: 15,
  ISSUE_ID_SUPPORT_CLASS_MODAL: 4,
  ISSUE_ID_COMPLAIN: 17,
  ISSUE_ID_TICKET_1: 1,
  ISSUE_ID_TICKET_2: 2,
  ISSUE_ID_TICKET_3: 3,
  ISSUE_ID_ADJUST_THE_SCHEDULE: 13,
  REMINDER_FROM_KYNA: 14,
}
export const BY_TEACHER = 2

export const COUNTRY_CODE = {
  VN: 'vn',
  ID: 'id',
  TH: 'th',
  EN: 'en',
}

export const LANGUAGE_CODE = {
  VN: 'vi',
  EN: 'en',
  TH: 'th',
  ID: 'id',
}

export const PROGRAM_ID = {
  VIP: 1,
  SPEAK: 2,
  DEMO: 3,
  TUTORIALS: 4,
  CLASS: 5,
  JUNIOR: 6,
  PRIMARY: 7,
  TEST_ONLINE: 8,
  SPEAK_JUNIOR: 9,
  IELTS: 10,
  PRIMARY_MATH_II: 12,
  TEST_ONLINE_60: 13,
  CLASS_VIP: 14,
  CLASS_SPEAK: 15,
  SECONDARY: 16,
  VIP45: 17,
  SPEAK45: 18,
  PRIMARY_MATH_I: 20,
  GROUP_TALK_KID: 64,
  GROUP_TALK_ADULT: 65,
  SOLVE_EXERCISE: 112,
  DUO_GROUP_SPEAK: 135,
  DUO_GROUP_ADULT: 138,
  LIVE_HUB: 137,
  DUO_GROUP_START: 144,
}

export const PROGRAM_IDS_HIDE_EVALUATION = [
  PROGRAM_ID.GROUP_TALK_KID,
  PROGRAM_ID.GROUP_TALK_ADULT,
  PROGRAM_ID.SOLVE_EXERCISE,
  PROGRAM_ID.LIVE_HUB,
]

export const RATING_ID = {
  BEING_CHECKED: 0,
  WITHOUT_BONUS: 1,
  WITH_BONUS: 2,
  INADEQUATE_TEACHING_TIME: 3,
  NO_PAY: 4,
}

export const RATING_LIST = ['N/A', 'Fair', 'Satisfactory', 'Good', 'Excellent']

export const RATING_LEVEL = {
  0: 'Being checked',
  1: 'Without bonus',
  2: 'With bonus',
  3: 'Below standard',
  4: 'No pay',
  // 5: 'N/A',
  6: 'No pay - Base rate',
  // 7: 'Cancel by Teacher',
  98: 'Being checked',
  99: 'Talking Time',
  100: 'Camera',
}

export const SUBJECT_ID = {
  ENGLISH: 1,
  MATH: 2,
  CHINESE: 3,
}

export const CHILDREN_TYPE = {
  KID: 1,
  ADULT: 2,
}

export const SUPPORT_GROUP = {
  ACADEMIC: 'academic',
  OPS: 'ops',
}

export const APP_NAME = {
  ENGLISH: 'english',
  TEACHER: 'web-teacher',
  SCHOOL: 'school',
  STAR: 'app-kyna-star',
}

export const ROOT_CHAT = 'kynateacher-app-chat'

export const ROOT_CONVERSATION = 'teacher-chat'

export const CHAT_USER_TYPE = {
  ACADEMIC: 'chat-teacher-academic',
  OPS: 'chat-teacher-ops',
}

export const CONVERSATION_STATUS = {
  NEW: 1,
  PROCESSING: 2,
  COMPLETED: 3,
}

export const CONVERSATION_SUBJECT_TYPE = {
  WRONG_LESSON: 6,
  OTHER: 8,
  CAN_NOT_JOIN_CLASS: 9,
  SUPPORT_JOIN_CLASS: 12,
}

export const MESSAGE_TYPE = {
  TEXT: 'text',
  FILE: 'file',
  INVITE: 'action_invite',
  NOTIFICATION_MESSAGE: 'action_notification_message',
  OPTIONS: 'options',
  CONVERSATION_END: 'conversation_end',
  FEEDBACK: 'feedback',
  AUTO_CONVERSATION: 'auto_conversation',
}

export const FILE_TYPE = {
  IMAGE: 'image',
  PDF: 'pdf',
}

export const LMS_TYPE = {
  WIZIQ: 1,
  BBB: 2,
  CLASSIN: 3,
  GOOGLE_ZALO_ZOOM: 6,
}

export const TEACHER_TYPE = {
  KYNA: 1,
  RARE_JOB: 2,
  GGE: 3,
  MURPHER: 4,
  TEACHER_SOURCE_BACK_OFFICE: 5,
}

export const CONTRACT_STATUS = {
  PENDING: 1,
  WAITING_APPROVE: 2,
  REQUEST: 3,
  APPROVED: 4,
  EXPIRE: 5,
  REQUEST_UPDATE: 6,
  AFTER_UPDATING: 7,
}

export const TEACHER_TYPE_TRAINING = {
  TESTER: 0,
  OFFICIAL: 1,
  ALL: 2,
}

export const TRAINING_STATUS = {
  TRAINING_STATUS_NOT_YET: 1,
  TRAINING_STATUS_DONE: 2,
  TRAINING_STATUS_TEST: 3,
  TRAINING_STATUS_TEACHING: 4,
}

export const REGISTERED_TRAINING_STATUS = {
  NOT_REGISTERED: 1,
  REGISTERED_BOTH: 2,
  REGISTERED_TEST: 3,
  REGISTERED_TEACHING: 4,
}

export const METHOD_ID = {
  VN_BANK: 1,
  PAYPAL: 2,
  INTERNATIONAL_BANK: 3,
}

export const METHOD_VN_OPTIONS = [
  { id: METHOD_ID.VN_BANK, name: 'VN Bank' },
  // { id: METHOD_ID.PAYPAL, name: 'Paypal (if any)' },
]

export const METHOD_INTERNATIONAL_OPTIONS = [
  { id: METHOD_ID.INTERNATIONAL_BANK, name: 'International Bank' },
  // { id: METHOD_ID.PAYPAL, name: 'Paypal (if any)' },
]

export const CURRENCY_OPTIONS = [
  { label: 'USD', value: 'USD' },
  { label: 'VND', value: 'VND' },
]

export const CONTRACT_TITLE = ['', 'Pending', 'Waiting approve', 'Request', 'Approved', 'Expire']

export const TYPE_CLASSES = {
  YOUR_CLASSES: 'your-classes',
  AVAILABLE_CLASSES: 'available-classes',
}

export const TIMEZONE = {
  HCM: 'Asia/Ho_Chi_Minh',
}

export const TEACHER_GENDER = {
  MALE: 1,
  FEMALE: 2,
}
